exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{color:#201350 !important;font-weight:700 !important;font-size:50px !important}h2{color:#201350 !important;font-weight:700 !important;font-size:35px !important}h3{color:#323232 !important;font-weight:300 !important;font-size:23px !important}.paragraph{margin-top:2rem;margin-bottom:2rem;width:100%;text-align:center;border-bottom:1px solid #ccc;line-height:0.1em}.span{background:#f1f1f1;padding:0 10px}\n", ""]);

// exports
